export const getNumFulfilled = <T>(
  results: PromiseSettledResult<T>[],
): number => results.filter((res) => res.status === 'fulfilled').length;
